var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-button',{directives:[{name:"test-id",rawName:"v-test-id",value:(_vm.attrTestId),expression:"attrTestId"}],attrs:{"secondary":"","color":_vm.attrColor,"icon-left":"logout","text":_vm.text || _vm.buttonText},on:{"click":_vm.logout}})}
var staticRenderFns = []

export { render, staticRenderFns }